module.exports = __webpack_public_path__ + "media/images/LandRover-4253fe4db64b28946dca3950f75220b9.svg";